<template>
  <section class="search-component">
    <Index
      v-show="currentContext === 'Courses'"
      :index="courseIndex"
      :facets="facets.courseFacets"
      tileType="course"
      :viewStyle="viewStyle"
      :currentSearchQuery="globalSearchQuery"
      :customFacet="customFacet"
    />
    <Index
      v-show="currentContext === 'Learning Paths'"
      :index="playlistIndex"
      :facets="facets.playlistFacets"
      tileType="playlist"
      :viewStyle="viewStyle"
      :currentSearchQuery="globalSearchQuery"
      :customFacet="customFacet"
    />
    <Index
      v-show="currentContext === 'Videos'"
      :index="videoIndex"
      :facets="facets.videoFacets"
      tileType="video"
      :viewStyle="viewStyle"
      :currentSearchQuery="globalSearchQuery"
      :customFacet="customFacet"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Index from '@/components/search/search-components/Index.vue'

export default {
  name: 'SearchResults',
  components: {
    Index,
  },
  props: {
    customFacet: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      courseIndex: process.env.VUE_APP_ALGOLIA_COURSES_INDEX,
      playlistIndex: process.env.VUE_APP_ALGOLIA_PLAYLISTS_INDEX,
      videoIndex: process.env.VUE_APP_ALGOLIA_VIDEOS_INDEX,
      facets: {
        courseFacets: [
          { title: 'Features', facet: 'features' },
          { title: 'Learning Area', facet: 'all_categories.name' },
          { title: 'Category', facet: 'categories.name' },
          { title: 'Vendor', facet: 'vendor' },
          { title: 'Instructor', facet: 'instructor' },
          { title: 'Difficulty', facet: 'difficulties.title' },
        ],
        playlistFacets: [
          { title: 'Head Instructor', facet: 'head_instructor.full_name' },
          { title: 'Instructor', facet: 'instructors.full_name' },
        ],
        videoFacets: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      globalSearchQuery: 'search/searchQuery',
      currentContext: 'search/searchContext',
      viewStyle: 'search/viewStyle',
    }),
  },
}
</script>
